export const FINANCIALS_CATEGORY = '7c8575b4-34d1-4520-933a-653867f7eacc';
export const LENDER_PRESENTATIONS_CATEGORY = '286cdf84-79c1-4781-bb0a-d157ef737d56';
export const ORG_CHART_CATEGORY = '9b73fac4-c077-42a9-b4be-c5fb6987b699';
